
export const georgeMediaArray = [
  {
    _id: 'georgeMediaId1',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "I didn't do the report my boss is asking me for" face`,
      `Mid-scheme`,
      `My "About to quit my job and immediately regret it" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId2',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Welcome to my dementia`,
      `If you like petty men it's your lucky day`,
      `IF IT'S ANYONE IT'S ME!`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId3',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-3-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend I'm thinking something profound`,
      `Warning: wears glasses and blazers to trick people into thinking I look smart`,
      `What are you gonna do`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId4',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-4-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "I didn't do the report my boss is asking me for" face`,
      `Mid-scheme`,
      `My "About to quit my job and immediately regret it" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId5',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `I'll be there in a second, I'm mid-scheme`,
      `Warning: wears glasses and blazers to trick people into thinking I look smart`,
      `Welcome to my dementia`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId6',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-6-p.png`,
    description: ``,
    captions: [
      `I thought I deleted this one`,
      `#MondaysAmIRight?`,
      `Life outtake`
    ],
    subcaptions: [
      `Gortex, not an ape suit`,
      `Gortex, not a punching bag costume`,
      `Even a hothead needs a winter coat` 
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId7',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-7-p.png`,
    description: ``,
    captions: [
      `Me during Fashion Week`,
      `My uniform`,
      `Leave a one-word review for this`
    ],
    subcaptions: [
      `The world is your catwalk`,
      `Welcome to my boudoir`,
      `Options include 'masculine', 'viral', and 'heartthrob'`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId8',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-8-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend I'm thinking something profound`,
      `Warning: wears glasses and sweaters to trick people into thinking I look smart`,
      `One second, mid-scheme`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId9',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-9-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Let's assume I'm a serious maneuverer and not a serious idiot`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `Go out on a date with me or else`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId10',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-10-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Self-loathing bald man who tried out a toupé but had too much pride to keep wearing it`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `Are you Persian, because I've got quite the rug`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId11',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-11-p.png`,
    description: ``,
    captions: [
      `Me during Fashion Week`,
      `My uniform`,
      `Leave a one-word review for this`
    ],
    subcaptions: [
      `The world is your catwalk`,
      `Welcome to my boudoir`,
      `Options include 'masculine', 'viral', and 'heartthrob'`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId12',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-12-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `It's all about the simple things`,
      `Plandid or candid?`
    ],
    subcaptions: [
      `Humans descended from apes and apparently dropped me off mid-journey`,
      `Intensely healthy eater`,
      `It has suddenly occured to me that I look ridiculous holding this banana`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId13',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-13-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Mid-scheme, I'll be there in a second`,
      `Warning: wears glasses to trick people into thinking I look smart`,
      `Welcome to my boudoir`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId14',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-14-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My uniform`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend this never happened`,
      `Really, I'm bald, unemployed, and I live with my parents`,
      `Extremely concerned that I may have finished the potato chips`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId15',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-15-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-15-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "Summer of George" outfit`,
      `I swear, 'Mailman chic' is in these days`,
      `Not wearing a hat to hide my bald head, I swear`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId16',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-16-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-16-p.png`,
    description: ``,
    captions: [
      `Me during Fashion Week`,
      `My uniform`,
      `Leave a one-word review for this`
    ],
    subcaptions: [
      `The world is your catwalk`,
      `Welcome to my boudoir`,
      `Options include 'masculine', 'viral', and 'heartthrob'`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId17',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-17-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-17-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `What's not to like`,
      `Pretty, prettttty, pretttttayyy good`,
      `My best effort at positivity`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'georgeMediaId18',
    userId: 'georgeUserId',
    email: 'george@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-18-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-18-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `I feel famous when`,
      `How my friends see me`
    ],
    subcaptions: [
      `Against all odds I have friends`,
      `Proof that I have friends`,
      `These people weren't paid to pose as friends, I swear`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]